import { makeAutoObservable } from 'mobx';
import { validatePositionPriceTrail } from './validatePositionPriceTrail';

export class PositionPriceTrailData {
  amount = 0;
  valueUnit = 'DOLLARS';

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach(
        (field) => (this[field] = initialData[field])
      );
    }
  }

  //common methods
  resetToDefaults = () => {
    this.amount = 0;
    this.valueUnit = 'DOLLARS';
  };
  updateTactic = (dataObj) => {
    for (const key in dataObj) {
      this[key] = dataObj[key];
    }
  };
  validate = () => {
    const result = validatePositionPriceTrail(this.amount);
    return result;
  };
  returnJson = () => {
    return {
      amount: this.amount,
      valueUnit: this.valueUnit,
    };
  };

  //specific methods
  setAmount = (number) => {
    this.amount = number;
  };
  setValueUnit = (unit) => {
    this.valueUnit = unit;
  };
}
